module.exports = __webpack_public_path__ + "static/media/person-fill.67345d14.svg";